// src/pages/payment/PaymentFailed.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
      <XCircle className="w-16 h-16 text-red-500 mb-4" />
      <h1 className="text-2xl font-bold text-center mb-4">
        Ödeme Başarısız
      </h1>
      <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
        Ödeme işlemi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.
      </p>
      <div className="space-x-4">
        <button
          onClick={() => navigate('/payment')}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Tekrar Dene
        </button>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default PaymentFailed;